module.exports = __webpack_public_path__ + "static/media/login-form-min.deb9f414.png";